/* Ganga Shop V2 · chips y atajos del menú que apuntan a un ancla (11/10/2026)
   Ej.: "Más vendidos" → /#mas-vendidos. Si el ancla está en esta misma página, se baja directo sin recargar
   (la home suele abrirse con ?fbclid o ?utm y el link sin esos parámetros recargaba la página entera).
   Desde el menú, primero se cierra el menú (bloquea el scroll mientras está abierto) y después se baja.
   Si el ancla no existe en esta página, el link funciona normal.
   Además: si el chip de la página actual (aria-current) quedó fuera de la fila, la fila se corre para que se vea
   (una sola medida al cargar, nada en el scroll). */
(function () {
  function chipActual() {
    var chip = document.querySelector('.gs-chips__chip[aria-current="page"]');
    var fila = chip && chip.closest('.gs-chips__lista');
    if (!fila || fila.scrollWidth <= fila.clientWidth) return;
    var r = chip.getBoundingClientRect();
    var f = fila.getBoundingClientRect();
    /* si queda tapado por el borde (o el degradé), se centra */
    if (r.right > f.right - 32) fila.scrollLeft += (r.left + r.width / 2) - (f.left + f.width / 2);
  }
  /* después de load: el CSS de los chips puede llegar tarde y antes la fila todavía no desborda */
  if (document.readyState === 'complete') chipActual();
  else window.addEventListener('load', chipActual);

  function bajar(el, hash) {
    el.scrollIntoView({ block: 'start' });
    if (history.replaceState) history.replaceState(history.state, '', hash);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gs-chips a[href*="#"], .gs-menu-atajos a[href*="#"]');
    if (!a) return;
    var destino = new URL(a.href, location.href);
    if (destino.origin !== location.origin || destino.pathname !== location.pathname || !destino.hash) return;
    var el = document.getElementById(decodeURIComponent(destino.hash.slice(1)));
    var menu = a.closest('menu-drawer');
    if (!el) {
      // En la misma página pero sin el ancla: solo se cierra el menú para que no quede tapando.
      if (menu && typeof menu.hide === 'function') { e.preventDefault(); menu.hide(); }
      return;
    }
    e.preventDefault();
    if (!menu || typeof menu.hide !== 'function' || !menu.hasAttribute('open')) {
      bajar(el, destino.hash);
      return;
    }
    var listo = false;
    function despuesDeCerrar() {
      if (listo) return;
      listo = true;
      setTimeout(function () { bajar(el, destino.hash); }, 50);
    }
    var cierre = menu.hide();
    if (cierre && typeof cierre.then === 'function') cierre.then(despuesDeCerrar);
    setTimeout(despuesDeCerrar, 900); // por si la transición no avisa
  });
})();
